import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "stat" }
const _hoisted_4 = { class: "stat-value" }
const _hoisted_5 = { class: "stat" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = {
  class: "title",
  colspan: "3"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "select-list" }
const _hoisted_10 = ["src", "alt", "onClick"]
const _hoisted_11 = { class: "tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.displayName(_ctx.weaponMaster.名前)), 1),
              _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.displayName("基礎攻撃力")), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.displayStatValue("基礎攻撃力", _ctx.stats[0].value)), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: _ctx.weaponMaster.レアリティ }, (_, i) => i), (i) => {
                  return (_openBlock(), _createElementBlock("img", {
                    class: "star",
                    src: "images/star.png",
                    alt: "star",
                    key: i
                  }))
                }), 128))
              ]),
              _createElementVNode("th", _hoisted_5, [
                (_ctx.stats[1])
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.displayName(_ctx.stats[1].key)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_6, [
                (_ctx.stats[1])
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.displayStatValue(_ctx.stats[1].key, _ctx.stats[1].value)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.weaponMaster.武器スキル)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.weaponMaster.武器スキル.名前), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: "3",
                      class: "description",
                      innerHTML: _ctx.weaponMaster.武器スキル.説明
                    }, null, 8, _hoisted_8)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "icon",
              key: item.key
            }, [
              _createElementVNode("img", {
                class: _normalizeClass('weapon' + _ctx.bgImageClass(item) + _ctx.selectedClass(item)),
                src: item.icon_url,
                alt: item.key,
                onClick: ($event: any) => (_ctx.updateWeapon(item.key))
              }, null, 10, _hoisted_10),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.displayName(item.key)), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}